/**
 * For indicate a page state usage
 * @export EnumPagMode
 * @enum
 */


enum EnumPagMode {
    View = 0,
    Edit,
}

export default EnumPagMode
